var _circle, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 482,
    viewBox: "0 0 600 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 208,
    r: 205,
    fill: "url(#paint0_radial_1204_149440)",
    stroke: "white",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1204_149440",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(244.894 -48.503) scale(379.953 458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD4646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#950101"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    d: "M216.788 252.712L0 127.534L50.2092 54.312L305.276 201.601L216.788 252.712Z",
    fill: "url(#paint0_linear_1204_149441)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.053 382.91L81.957 298.555L198.06 231.51L344.156 315.866L228.053 382.91Z",
    fill: "#530404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.053 223.689L81.957 139.334L198.06 72.2894L344.156 156.645L228.053 223.689Z",
    fill: "url(#paint1_linear_1204_149441)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M344.15 247.134V156.645L228.047 223.689V314.178L344.15 247.134Z",
    fill: "url(#paint2_linear_1204_149441)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.957 139.334V229.822L228.053 314.178V223.689L81.957 139.334Z",
    fill: "url(#paint3_linear_1204_149441)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.797 118.155L108.547 154.689V174.266L127.32 185.111V165.533L190.57 129L171.797 118.155Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.969 141.356L148.719 177.867V197.445L167.492 208.289V188.712L230.742 152.178L211.969 141.356Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M252.203 164.577L188.953 201.088V220.666L207.726 231.51V211.932L270.976 175.421L252.203 164.577Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.797 118.155V126.044L183.86 132.866L190.57 129L171.797 118.155Z",
    fill: "#FFA3B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.345 170.221L108.547 174.266L127.32 185.11V176.955L115.345 170.221Z",
    fill: "#FFA3B9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M171.797 118.155L108.547 154.689V174.266L115.345 170.222V158.666L171.819 126.044L171.797 118.155Z",
    fill: "url(#paint4_linear_1204_149441)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M211.969 141.356V149.245L224.032 156.067L230.742 152.178L211.969 141.356Z",
    fill: "#FFA3B9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.539 193.4L148.719 197.445L167.492 208.289V200.134L155.539 193.4Z",
    fill: "#FFA3B9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M211.969 141.356L148.719 177.867V197.445L155.539 193.401V181.845L212.013 149.245L211.969 141.356Z",
    fill: "url(#paint5_linear_1204_149441)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M252.199 164.577V172.466L264.263 179.288L270.972 175.421L252.199 164.577Z",
    fill: "#FFA3B9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.751 216.623L188.953 220.667L207.726 231.512V223.379L195.751 216.623Z",
    fill: "#FFA3B9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M252.203 164.577L188.953 201.088V220.666L195.751 216.621V205.066L252.226 172.466L252.203 164.577Z",
    fill: "url(#paint6_linear_1204_149441)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M322.625 321.421L398.805 277.443V243.643L322.625 287.643V321.421Z",
    fill: "url(#paint7_linear_1204_149441)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M322.624 287.643L398.804 243.643L322.646 199.666L246.488 243.643L322.624 287.643Z",
    fill: "url(#paint8_linear_1204_149441)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M322.624 271.755L371.278 243.644L322.646 215.555L273.992 243.644L322.624 271.755Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M322.646 220.666L366.857 246.222L371.278 243.644L322.646 215.555L273.992 243.644L278.413 246.222L322.646 220.666Z",
    fill: "#FFA3B9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M322.646 201.332L397.36 244.488L398.804 243.643L322.646 199.666L246.488 243.643L247.91 244.488L322.646 201.332Z",
    fill: "#FF003D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M246.473 277.443L322.653 321.421V287.643L246.473 243.643V277.443Z",
    fill: "url(#paint9_linear_1204_149441)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M322.624 285.955L397.338 242.799L398.804 243.644L322.624 287.644L246.488 243.644L247.932 242.821L322.624 285.955Z",
    fill: "#DA5071"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M336.754 292.215C337.1 291.583 337.565 291.026 338.124 290.577C338.682 290.128 339.322 289.796 340.008 289.6C340.693 289.404 341.409 289.347 342.116 289.434C342.822 289.52 343.505 289.748 344.125 290.103L364.205 301.907C368.946 304.687 372.884 308.687 375.622 313.506C378.36 318.326 379.8 323.793 379.799 329.359V354.509C379.805 358.144 380.747 361.714 382.532 364.863C384.318 368.013 386.883 370.631 389.974 372.458L537.569 459.036C541.167 461.148 545.167 462.451 549.302 462.858C548.928 466.49 549.073 470.185 548.782 473.839C542.926 473.352 537.251 471.541 532.171 468.538L384.575 381.96C379.837 379.179 375.903 375.177 373.169 370.358C370.435 365.539 368.998 360.072 369.001 354.509V329.444C368.994 325.809 368.048 322.24 366.259 319.094C364.47 315.948 361.9 313.335 358.806 311.516L338.726 299.711C338.111 299.353 337.572 298.874 337.139 298.302C336.707 297.73 336.39 297.077 336.206 296.381C336.023 295.684 335.977 294.957 336.071 294.242C336.165 293.527 336.397 292.838 336.754 292.215Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M361.191 281.104C361.537 280.471 362.003 279.915 362.561 279.466C363.12 279.017 363.76 278.685 364.445 278.489C365.13 278.293 365.847 278.236 366.553 278.322C367.26 278.409 367.943 278.636 368.563 278.992L388.642 290.796C393.384 293.575 397.322 297.576 400.06 302.395C402.797 307.215 404.238 312.682 404.237 318.248V343.398C404.242 347.033 405.185 350.603 406.97 353.752C408.755 356.902 411.321 359.52 414.411 361.347L562.007 447.925C565.604 450.036 569.605 451.34 573.739 451.747C573.365 455.379 573.511 459.074 573.22 462.727C567.364 462.241 561.688 460.43 556.608 457.427L409.012 370.849C404.275 368.067 400.341 364.066 397.607 359.247C394.873 354.428 393.435 348.961 393.439 343.398V318.332C393.432 314.698 392.486 311.129 390.697 307.983C388.908 304.837 386.337 302.223 383.243 300.404L363.164 288.6C362.549 288.242 362.009 287.763 361.577 287.191C361.144 286.619 360.827 285.966 360.644 285.269C360.46 284.573 360.414 283.846 360.508 283.131C360.602 282.416 360.834 281.727 361.191 281.104Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M383.41 265.548C383.756 264.916 384.222 264.359 384.78 263.91C385.339 263.462 385.979 263.13 386.664 262.933C387.349 262.737 388.065 262.68 388.772 262.767C389.479 262.853 390.162 263.081 390.781 263.437L410.861 275.241C415.603 278.02 419.541 282.021 422.278 286.84C425.016 291.659 426.457 297.127 426.455 302.692V327.842C426.461 331.477 427.403 335.047 429.189 338.197C430.974 341.346 433.54 343.965 436.63 345.791L584.226 432.369C587.823 434.481 591.823 435.784 595.958 436.191C595.584 439.823 595.729 443.519 595.439 447.172C589.582 446.685 583.907 444.874 578.827 441.872L431.231 355.294C426.493 352.512 422.559 348.51 419.826 343.691C417.092 338.872 415.654 333.406 415.658 327.842V302.777C415.65 299.142 414.705 295.574 412.916 292.427C411.126 289.281 408.556 286.668 405.462 284.849L385.383 273.045C384.767 272.686 384.228 272.207 383.795 271.635C383.363 271.064 383.046 270.411 382.862 269.714C382.679 269.017 382.633 268.29 382.727 267.576C382.821 266.861 383.053 266.172 383.41 265.548Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M306.562 305.223L314.338 309.711V294.089L306.562 289.6V305.223Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M293.613 297.733L301.389 302.222V286.6L293.613 282.133V297.733Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M280.656 290.266L288.432 294.755V279.133L280.656 274.644V290.266Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M267.734 282.779L275.51 287.267V271.667L267.734 267.179V282.779Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M254.777 275.312L262.553 279.801V264.178L254.777 259.689V275.312Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M174.688 248.755C174.838 251.609 175.662 254.387 177.09 256.863C178.519 259.338 180.512 261.441 182.908 262.999C187.351 265.621 191.128 263.488 191.128 258.243C190.972 255.39 190.146 252.614 188.718 250.139C187.29 247.665 185.299 245.561 182.908 243.999C178.353 241.377 174.688 243.51 174.688 248.755Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M158.773 246.273C161.983 244.42 161.983 238.411 158.774 232.852C155.566 227.294 150.363 224.29 147.154 226.143C143.945 227.996 143.945 234.005 147.153 239.564C150.362 245.122 155.564 248.126 158.773 246.273Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M114.797 214.156C114.948 217.01 115.771 219.788 117.2 222.264C118.628 224.739 120.621 226.842 123.017 228.4C127.46 231.022 131.237 228.911 131.237 223.667C131.081 220.814 130.255 218.038 128.827 215.563C127.399 213.088 125.409 210.985 123.017 209.422C118.463 206.8 114.797 208.911 114.797 214.156Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M178.842 242.956C178.416 243.976 178.204 245.072 178.22 246.178C178.375 249.034 179.202 251.812 180.635 254.288C182.067 256.763 184.064 258.865 186.462 260.422C187.668 261.187 189.08 261.56 190.506 261.489C189.284 264.244 186.351 264.978 182.908 263C180.512 261.442 178.519 259.339 177.09 256.864C175.662 254.388 174.838 251.61 174.688 248.756C174.688 245.222 176.376 243.156 178.842 242.956Z",
    fill: "#FFA3B9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M148.893 225.644C148.459 226.67 148.247 227.775 148.271 228.889C148.426 231.745 149.253 234.523 150.685 236.999C152.118 239.474 154.115 241.576 156.513 243.133C157.723 243.887 159.132 244.259 160.556 244.2C159.335 246.955 156.402 247.689 152.958 245.711C150.563 244.153 148.569 242.05 147.141 239.575C145.712 237.099 144.889 234.321 144.738 231.467C144.738 227.933 146.427 225.844 148.893 225.644Z",
    fill: "#FFA3B9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M118.948 208.355C118.498 209.354 118.263 210.437 118.259 211.533C118.415 214.386 119.241 217.162 120.669 219.637C122.097 222.111 124.087 224.215 126.479 225.777C127.695 226.534 129.114 226.899 130.545 226.821C129.323 229.577 126.368 230.333 122.947 228.333C120.551 226.774 118.558 224.672 117.129 222.196C115.701 219.721 114.877 216.942 114.727 214.088C114.793 210.621 116.482 208.555 118.948 208.355Z",
    fill: "#FFA3B9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M368.679 144.555L300.719 105.288L354.727 74.1102L422.709 113.355L368.679 144.555Z",
    fill: "#530404"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M368.679 70.4666L300.719 31.2L354.727 0L422.709 39.2666L368.679 70.4666Z",
    fill: "url(#paint10_linear_1204_149441)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M422.71 81.3775V39.2664L368.68 70.4664V112.577L422.71 81.3775Z",
    fill: "url(#paint11_linear_1204_149441)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M300.719 31.2001V73.3111L368.679 112.578V70.4667L300.719 31.2001Z",
    fill: "url(#paint12_linear_1204_149441)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M342.515 21.3563L313.078 38.3563V47.4674L321.831 52.5118V43.4007L351.246 26.4008L342.515 21.3563Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M361.218 32.1549L331.781 49.1327V58.2438L340.512 63.2882V54.1771L369.949 37.1994L361.218 32.1549Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M379.929 42.9557L350.492 59.9557V69.0668L359.245 74.1112V65.0001L388.66 48.0001L379.929 42.9557Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M342.516 21.3563V25.023L348.136 28.2008L351.247 26.4008L342.516 21.3563Z",
    fill: "#FFA3B9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M316.255 45.5772L313.078 47.4661L321.831 52.5105V48.7105L316.255 45.5772Z",
    fill: "#FFA3B9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M342.515 21.3563L313.078 38.3563V47.4674L316.255 45.5785V40.2008L342.537 25.023L342.515 21.3563Z",
    fill: "url(#paint13_linear_1204_149441)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M361.219 32.1549V35.8216L366.817 38.9994L369.95 37.1994L361.219 32.1549Z",
    fill: "#FFA3B9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M334.936 56.378L331.781 58.2447L340.512 63.2891V59.5113L334.936 56.378Z",
    fill: "#FFA3B9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M361.218 32.1549L331.781 49.1327V58.2438L334.936 56.3771V50.9993L361.218 35.8216V32.1549Z",
    fill: "url(#paint14_linear_1204_149441)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M379.926 42.9557V46.6224L385.547 49.8001L388.657 48.0001L379.926 42.9557Z",
    fill: "#FFA3B9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M353.669 67.1788L350.492 69.0676L359.245 74.1121V70.3121L353.669 67.1788Z",
    fill: "#FFA3B9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M379.929 42.9557L350.492 59.9557V69.0668L353.669 67.1779V61.8001L379.951 46.6224L379.929 42.9557Z",
    fill: "#BA2537"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1204_149441",
    x1: 81.8455,
    y1: 46.6454,
    x2: 265.379,
    y2: 352.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1204_149441",
    x1: 227.231,
    y1: 158.934,
    x2: 19.7109,
    y2: -1.34755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C04B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1204_149441",
    x1: 228.047,
    y1: 235.423,
    x2: 344.15,
    y2: 235.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#950101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36276"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1204_149441",
    x1: 81.957,
    y1: 226.756,
    x2: 228.053,
    y2: 226.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#950101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D25875"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1204_149441",
    x1: 5336.75,
    y1: 3965.69,
    x2: 7138.76,
    y2: 3965.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA2537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1204_149441",
    x1: 6523.13,
    y1: 4572.93,
    x2: 8326.39,
    y2: 4572.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1204_149441",
    x1: 7706.99,
    y1: 5182.29,
    x2: 9508.99,
    y2: 5182.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA2540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1204_149441",
    x1: 149321,
    y1: 9269.68,
    x2: 146001,
    y2: 11512.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#950101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D42D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1204_149441",
    x1: 379.743,
    y1: 219.11,
    x2: 272.206,
    y2: 265.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D47373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1204_149441",
    x1: 146890,
    y1: 9846.01,
    x2: 143381,
    y2: 10882.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3666E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1204_149441",
    x1: 24643.9,
    y1: 1474.87,
    x2: 21608.4,
    y2: -2585.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94568"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1204_149441",
    x1: 11160.2,
    y1: 2747.38,
    x2: 12473.7,
    y2: 2747.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33F67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC3E64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1204_149441",
    x1: 11794.8,
    y1: 2890,
    x2: 13874.4,
    y2: 2890,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D53A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA2549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1204_149441",
    x1: 5459.27,
    y1: 498.145,
    x2: 5849.9,
    y2: 498.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#FF003D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1204_149441",
    x1: 5721.96,
    y1: 635.329,
    x2: 6112,
    y2: 635.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA2537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Icon);
export default __webpack_public_path__ + "static/media/404_icon.aaae77520f4de304ff71ea2eeec8830a.svg";
export { ForwardRef as ReactComponent };